import Termos from "./termos";

export default Termos;
